const CarteirasModule = {
    state: {
        carteiraAtualSalva: false,
        emailSalvo: ''
    },
    getters: {
        getCarteiraAtualSalva(state) {
            return state.carteiraAtualSalva;
        },
        getEmailSalvo(state) {
            return state.emailSalvo;
        }
    },
    mutations: {
        setCarteiraAtualSalva(state, salva) {
            state.carteiraAtualSalva = salva;
        },
        setEmailSalvo(state, email) {
            state.emailSalvo = email;
        }
    },
    actions: {
        
    }
}

export default CarteirasModule;